import { STUB_COMMENT_ID } from "../const/const";
import { TComment } from "../model/types/types";

type TStubCommentInput = {
  firstName: string;
  lastName: string;
  content: string;
  userId: number;
};

export const generateStubComment = ({ userId, firstName, lastName, content }: TStubCommentInput): TComment => {
  return {
    id: STUB_COMMENT_ID,
    content,
    createdAt: new Date().toISOString(),
    author: {
      id: userId,
      firstName,
      lastName
    },
    parent: null,
    replies: []
  };
};
